import { useId } from "react";

export const InputField = ({ label, error, className, id, ...props }: any) => {
	const generatedId = useId();
	const fieldId = id || `input-${generatedId}`;
	return (
		<div className="space-y-1">
			<label htmlFor={fieldId} className="text-sm font-medium text-gray-300">
				{label}
			</label>
			<input
				id={fieldId}
				className={`w-full px-3 py-2 bg-brown rounded-md text-off-white focus:outline-none focus:ring-2 transition-all ${
					error
						? "ring-2 ring-red-500/80 focus:ring-red-500/80"
						: "focus:ring-mgt-green"
				} ${className || ""}`}
				aria-invalid={error ? true : undefined}
				{...props}
			/>
			{error ? (
				<p className="text-red-400 text-xs mt-0.5" role="alert">
					{error}
				</p>
			) : null}
		</div>
	);
};
